/**
 * Sprint DS B1-B2: Confetti Celebration System
 *
 * - Deal won: 40 particles, brand colors, 600ms
 * - Variable rewards: fires 20% of the time (random)
 * - Milestones (10th/50th/100th): full-screen banner variant
 */
// @ts-expect-error — canvas-confetti has no type declarations
import confetti from "canvas-confetti";

const BRAND_COLORS = ["#1040CC", "#7C3AED", "#F05E0A", "#16A34A"];

/**
 * Fire a confetti burst with brand colors.
 * @param intensity "normal" (40 particles) or "milestone" (150 particles)
 */
export function fireBrandConfetti(intensity: "normal" | "milestone" = "normal") {
  const count = intensity === "milestone" ? 150 : 40;
  const spread = intensity === "milestone" ? 100 : 60;

  confetti({
    particleCount: count,
    spread,
    origin: { y: 0.7 },
    colors: BRAND_COLORS,
    disableForReducedMotion: true,
    ticks: intensity === "milestone" ? 200 : 100,
  });
}

/**
 * Variable reward — fires confetti 20% of the time.
 * Returns true if confetti was fired.
 */
export function maybeFireConfetti(): boolean {
  if (Math.random() < 0.2) {
    fireBrandConfetti("normal");
    return true;
  }
  return false;
}
